import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-numbersquarezero",
  "use": "icon-th-numbersquarezero-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-numbersquarezero\">\n<path d=\"M16 9C14.2213 9 12.75 9.805 11.75 11.3263C10.9412 12.5588 10.5 14.2188 10.5 16C10.5 17.7812 10.945 19.4412 11.75 20.6737C12.75 22.195 14.2175 23 16 23C17.7825 23 19.25 22.195 20.25 20.6737C21.0588 19.4412 21.5 17.7812 21.5 16C21.5 14.2188 21.055 12.5588 20.25 11.3263C19.25 9.805 17.7787 9 16 9ZM16 21C13.2375 21 12.5 17.8575 12.5 16C12.5 14.1425 13.2375 11 16 11C18.7625 11 19.5 14.1425 19.5 16C19.5 17.8575 18.7625 21 16 21ZM26 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V26C4 26.5304 4.21071 27.0391 4.58579 27.4142C4.96086 27.7893 5.46957 28 6 28H26C26.5304 28 27.0391 27.7893 27.4142 27.4142C27.7893 27.0391 28 26.5304 28 26V6C28 5.46957 27.7893 4.96086 27.4142 4.58579C27.0391 4.21071 26.5304 4 26 4ZM26 26H6V6H26V26Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-numbersquarezero.svg
// module id = Izdq
// module chunks = 84